import axios from 'axios';
import { getDomainConfig } from 'utils/whiteLabel';
import { curlLogger } from 'utils/apiLogger';

const config = getDomainConfig();

export const socketAPI = `${config.apiUrl}/`;

export const baseURL = `${config.apiUrl}/v1`;

const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// IMPORTANT: Axios request interceptors run in LIFO order (last added runs first)
// So we add curlLogger FIRST (runs second) and auth SECOND (runs first)

api.interceptors.request.use(curlLogger.request);

// Add Authorization header to all requests automatically
api.interceptors.request.use(config => {
  const token = localStorage.getItem('_UFT_');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = token;
  }
  return config;
});

api.interceptors.response.use(response => response, curlLogger.error);

export default api;
